const prefix = 'cvf-admin/instances/';

export const GET_INSTANCES = `${prefix}GET_INSTANCES`;
export const GET_INSTANCES_SUCCESS = `${prefix}GET_INSTANCES_SUCCESS`;
export const GET_INSTANCES_ERROR = `${prefix}GET_INSTANCES_ERROR`;

export const GET_INSTANCES_STATUSES = `${prefix}GET_INSTANCES_STATUSES`;
export const GET_INSTANCES_STATUSES_SUCCESS = `${prefix}GET_INSTANCES_STATUSES_SUCCESS`;
export const GET_INSTANCES_STATUSES_ERROR = `${prefix}GET_INSTANCES_STATUSES_ERROR`;

export const UPDATE_INSTANCE = `${prefix}UPDATE_INSTANCE`;
export const UPDATE_INSTANCE_SUCCESS = `${prefix}UPDATE_INSTANCE_SUCCESS`;
export const UPDATE_INSTANCE_ERROR = `${prefix}UPDATE_INSTANCE_ERROR`;
